var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.dialog
    ? _c(
        "ModalFullScreen",
        {
          staticStyle: { display: "none" },
          attrs: { size: "md" },
          on: {
            close: function ($event) {
              return _vm.$emit("closeModal")
            },
          },
        },
        [
          _c("div", { staticClass: "modal-height-cropper relative" }, [
            _c(
              "div",
              {
                staticClass:
                  "placeholder-bg flex flex-col items-center justify-center absolute inset-0 z-0",
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "h-16 w-16 text-gray-400 mb-4",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M3 7h2l2-3h10l2 3h2a2 2 0 012 2v10a2 2 0 01-2 2H3a2 2 0 01-2-2V9a2 2 0 012-2z",
                      },
                    }),
                    _c("circle", { attrs: { cx: "12", cy: "13", r: "4" } }),
                  ]
                ),
                _vm.loading
                  ? _c("span", { staticClass: "text-gray-500 text-lg" }, [
                      _vm._v("Loading image…"),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm.image && _vm.loading
              ? _c("img", {
                  staticStyle: { display: "none" },
                  attrs: { src: _vm.image },
                  on: { load: _vm.onImageLoaded },
                })
              : _vm._e(),
            !_vm.loading && _vm.image
              ? _c(
                  "div",
                  {
                    staticClass:
                      "cropper-overlay absolute inset-0 z-10 flex flex-col justify-start",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "cropper-area flex items-center justify-center",
                        staticStyle: { height: "440px" },
                      },
                      [
                        _c("Cropper", {
                          ref: "cropper",
                          staticClass: "cropper",
                          attrs: {
                            src: _vm.image,
                            backgroundClass: "bg-white",
                            "stencil-props": { aspectRatio: 1 },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "flex justify-end p-4" },
                      [
                        _c("UiButton", {
                          staticClass: "ml-2",
                          attrs: {
                            variant: "outline",
                            size: "sm",
                            buttonText: "Cancel",
                          },
                          on: { click: _vm.handleClose },
                        }),
                        _c("UiButton", {
                          staticClass: "ml-2",
                          attrs: { size: "sm", buttonText: "Save" },
                          on: { click: _vm.uploadImage },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }